export default {
  copy: 'Example CTA',
  href: {
    url: 'http://www.bbc.co.uk/news',
    linktype: 'url',
    fieldtype: 'multilink',
    cached_url: 'http://www.bbc.co.uk/news',
  },
  component: 'a-cta',
}
